module.exports = __webpack_public_path__ + "static/media/bar-chart.07612344.svg";